export default [
  {
    path: 'service',
    name: 'Service',
    component: () => import('@/views/Service/Index.vue'),
    meta: {
      key: '3',
    }
  },
  // 工单详情
  {
    path: 'serviceDetail',
    name: 'ServiceDetail',
    component: () => import('@/views/Service/ServiceDetail.vue'),
    meta: {
      key: '3',
    }
  },
  // 清点核对
  {
    path: 'checkoff',
    name: 'CheckOff',
    component: () => import('@/views/Service/CheckOff.vue'),
    meta: {
      key: '3',
    }
  },
  // 分箱服务
  {
    path: 'binning',
    name: 'Binning',
    component: () => import('@/views/Service/Binning.vue'),
    meta: {
      key: '3',
    }
  },
  // 退货转寄
  {
    path: 'return_forward',
    name: 'ReturnForward',
    component: () => import('@/views/Service/ReturnForward.vue'),
    meta: {
      key: '3',
    }
  },
  // 拍照服务
  {
    path: 'photos',
    name: 'Photos',
    component: () => import('@/views/Service/Photos.vue'),
    meta: {
      key: '3',
    }
  },
  // 废弃申请
  {
    path: 'nullification',
    name: 'Nullification',
    component: () => import('@/views/Service/Nullification.vue'),
    meta: {
      key: '3',
    }
  },
]